import { __awaiter, __generator } from "tslib";
import { VoiceCommandResultV2, WordVoiceCommandIds } from '@augloop-types/voice';
import * as AugLoopUtils from './utils/AugLoopUtils';
import { sendSpeechToTextFinalResultToSpeechClientObserver } from './SpeechToTextClient';
import { getValidCommandSet, hasValidCommandValues, alterCommandValue } from './utils/validCommandUtil';
// Represents a will receive voice commands from AL.
var VoiceCommandingClient = /** @class */ (function () {
    function VoiceCommandingClient(alRuntimeManager, fdVoiceCommandClientObserver, fdSpeechClientObserver, enableExperimentalCommands) {
        var _this = this;
        this.voiceCommandRequestToken = null;
        this.alRuntimeManager = alRuntimeManager;
        this.fdVoiceCommandClientObserver = fdVoiceCommandClientObserver;
        this.fdSpeechClientObserver = fdSpeechClientObserver;
        this.validVoiceCommands = getValidCommandSet(!!enableExperimentalCommands);
        this.annotationObserver = {
            onAnnotationResult: function (op) {
                _this.onAnnotationResult(op);
            }
        };
    }
    // Initialize voice commanding client.
    VoiceCommandingClient.prototype.initializeAsync = function (sessionTelemetry) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var _c, err_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (this.voiceCommandRequestToken !== null) {
                            throw new Error('VoiceCommandingClient was already initialized.');
                        }
                        if (sessionTelemetry)
                            this.sessionTelemetry = sessionTelemetry;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        _c = this;
                        return [4 /*yield*/, AugLoopUtils.activateAnnotationAsync(this.alRuntimeManager, VoiceCommandResultV2.getTypeName())];
                    case 2:
                        _c.voiceCommandRequestToken = _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _d.sent();
                        (_a = this.sessionTelemetry) === null || _a === void 0 ? void 0 : _a.onAugloopError((_b = err_1.message, (_b !== null && _b !== void 0 ? _b : 'VoiceCommandingClient.initializeAsync')));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Uninitialize voice commanding client.
    VoiceCommandingClient.prototype.uninitializeAsync = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(this.voiceCommandRequestToken !== null)) return [3 /*break*/, 5];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, AugLoopUtils.releaseAnnotations(this.alRuntimeManager, [this.voiceCommandRequestToken])];
                    case 2:
                        _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _c.sent();
                        (_a = this.sessionTelemetry) === null || _a === void 0 ? void 0 : _a.onAugloopError((_b = err_2.message, (_b !== null && _b !== void 0 ? _b : 'VoiceCommandingClient.uninitializeAsync')));
                        return [3 /*break*/, 4];
                    case 4:
                        this.voiceCommandRequestToken = null;
                        _c.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // Return an annotation observer implemented by us that app will use to forward annotations to us.
    VoiceCommandingClient.prototype.getAnnotationObserver = function () {
        return this.annotationObserver;
    };
    // Handle an annotation result.
    VoiceCommandingClient.prototype.onAnnotationResult = function (op) {
        var _this = this;
        var voiceCommandItems = AugLoopUtils.filterOperationByAnnotationTypeName(op, VoiceCommandResultV2.getTypeName());
        voiceCommandItems.forEach(function (item) {
            _this.handleCommandResult(item.body);
        });
    };
    /** Handler for voice command V2 format */
    VoiceCommandingClient.prototype.handleCommandResult = function (commandResult) {
        if (commandResult.error && this.sessionTelemetry) {
            this.sessionTelemetry.onCommandError("handleCommandResult:" + commandResult.error);
        }
        for (var _i = 0, _a = commandResult.commandList; _i < _a.length; _i++) {
            var command = _a[_i];
            var isCommandSupported = this.validVoiceCommands.has(command.commandId) && hasValidCommandValues(command);
            // If type is InsertText or if this command is not supported, show it as a text
            if (command.commandId === WordVoiceCommandIds.InsertText || !isCommandSupported) {
                sendSpeechToTextFinalResultToSpeechClientObserver(this.fdSpeechClientObserver, commandResult.textAnnotation, command.sourceText, // FinalText
                this.sessionTelemetry);
            }
            else {
                // alter command if necessary
                var alteredCommand = alterCommandValue(command);
                this.fdVoiceCommandClientObserver.onVoiceCommand(alteredCommand);
            }
        }
    };
    return VoiceCommandingClient;
}());
export { VoiceCommandingClient };
//# sourceMappingURL=VoiceCommandingClient.js.map